import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	teamsLabel: {
		id: 'ptc-directory-ui.top-nav.label',
		defaultMessage: 'Teams app',
		description: 'Label for the top nav',
	},
});
